export const EmailsActionTypes = {
    API_RESPONSE_SUCCESS: '@@emails/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@emails/API_RESPONSE_ERROR',
    // Emails
    GET_EMAILS: '@@emails/GET_EMAILS',
    GET_EMAIL_BY_ID: '@@emails/GET_EMAIL_BY_ID',
    GET_EMAILS_BY_USER: '@@emails/GET_EMAILS_BY_USER',
    GET_EMAILS_BY_TRANSACTION: '@@emails/GET_EMAILS_BY_TRANSACTION',
    CREATE_EMAIL: '@@emails/CREATE_EMAIL',
    UPDATE_EMAIL: '@@emails/UPDATE_EMAIL',
    DELETE_EMAIL: '@@emails/DELETE_EMAIL',
    ARCHIVE_EMAIL: '@@emails/ARCHIVE_EMAIL',
    CREATE_ATTACHMENT: '@@emails/CREATE_ATTACHMENT',
    RESET_EMAILS: '@@emails/RESET_EMAILS',
};
